import { flagshipServices } from "../data/servicesData";
import MetaBadge from "./MetaBadge";

function MetaServiceCard() {
  return (
    <article className="meta-service-card">
      <div className="meta-service-card__head">
        <MetaBadge
          className="meta-service-card__badge"
          label="Meta Technology Integration Partner"
        />
        <span className="eyebrow">Flagship & Meta Integration Services</span>
        <h3 className="meta-service-card__title">
          Connect, Automate & Grow on the Meta Ecosystem
        </h3>
        <p className="meta-service-card__intro">
          As a Meta technology integration partner, we build end-to-end
          solutions on WhatsApp, Facebook and Instagram — powering customer
          conversations, campaigns and real-time workflows across your entire
          business.
        </p>
      </div>
      <div className="meta-service-card__list">
        {flagshipServices.map((service) => {
          const Wrapper = service.href ? "a" : "div";
          return (
            <Wrapper
              className="meta-service-card__item"
              key={service.id}
              {...(service.href
                ? { href: service.href, target: "_blank", rel: "noopener noreferrer" }
                : {})}
            >
              <div className="meta-service-card__icon" aria-hidden="true">
                <i className={`bi ${service.icon}`} />
              </div>
              <div className="meta-service-card__body">
                <span className="meta-service-card__tag">{service.tag}</span>
                <h4 className="meta-service-card__item-title">
                  {service.title}
                  {service.href && (
                    <i className="bi bi-box-arrow-up-right meta-service-card__external" />
                  )}
                </h4>
                <p className="meta-service-card__desc">{service.description}</p>
                <ul className="meta-service-card__features">
                  {service.features.map((feature) => (
                    <li key={feature}>
                      <i className="bi bi-check-lg" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </Wrapper>
          );
        })}
      </div>
    </article>
  );
}

export default MetaServiceCard;
